import PaidSearchAdGroupFitScoringTable from '@/app/paid-search/PaidSearchAdGroupFitScoringTable';
import PaidSearchKeywordFitScoringTable from '@/app/paid-search/PaidSearchKeywordFitScoringTable';

type Props = {
  breakdownType: 'adGroup' | 'keyword';
  adGroupIds: string[];
  keywordIds: string[];
};

const PaidSearchFitScoringTable = ({ breakdownType, adGroupIds, keywordIds }: Props) => {
  return (
    <>
      {breakdownType === 'adGroup' && <PaidSearchAdGroupFitScoringTable adGroupIds={adGroupIds} />}
      {breakdownType === 'keyword' && <PaidSearchKeywordFitScoringTable keywordIds={keywordIds} />}
    </>
  );
};

export default PaidSearchFitScoringTable;
